import { Reducer, Store } from "redux";
import createSagaMiddleware, { Saga } from "redux-saga";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import { appInitAction } from "../services/vk/actions";

import reducer from "./reducers";
import rootSaga from "./sagas";

const staticReducers = reducer;
const sagaMiddleware = createSagaMiddleware();

const middlewares = [thunk, sagaMiddleware];

const store = configureStore({
  reducer: staticReducers,
  devTools: true,
  middleware: middlewares,
});

const extendsStoreWithAsyncInjectors = (store: CustomStore) => {
  store.asyncReducers = {};
  store.injectReducer = (key, asyncReducer) => {
    store.asyncReducers[key] = asyncReducer;
    store.replaceReducer(
      combineReducers({
        ...staticReducers,
        ...store.asyncReducers,
      })
    );
  };

  store.injectSaga = ((runSaga, rootSaga) => {
    const injectedSagas = new Map();
    const isInjected = (key: string) => injectedSagas.has(key);

    const injectNewSaga = (key: string, saga: Saga) => {
      if (isInjected(key)) return;

      const task = runSaga(saga);
      injectedSagas.set(key, task);
    };

    injectNewSaga("root", rootSaga);
    return injectNewSaga;
  })(sagaMiddleware.run, rootSaga);
};

extendsStoreWithAsyncInjectors(store);

// store.dispatch(appInitAction());

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type CustomStore = Store & {
  asyncReducers?: { [key: string]: Reducer };
  injectReducer?: (key: string, asyncReducer: Reducer) => void;
  injectSaga?: (runSaga: string, defaultRootSaga: Saga) => void;
};

store.dispatch(appInitAction());

export default store;
